import NodeCache from 'node-cache';

class Cache {

    constructor(ttl) {
        this.cache = new NodeCache({ stdTTL: ttl, useClones: false });
    }

    get(key) {
        const value = this.cache.get(key);
        return Promise.resolve(value);
    }

    set(key, value, ttl){
        this.cache.set(key, value, ttl);
    }

    delete(key) {
        this.cache.del(key);
    }

    flush() {
        this.cache.flushAll();
    }

    getStats() {
        return this.cache.getStats();
    }
}

const cacheInstance = new Cache(5 * 60);

Object.freeze(cacheInstance);

export default cacheInstance;